"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Table = props => {
  const {
    prefix = '',
    fullWidth,
    inset,
    className,
    children,
    ...otherProps
  } = props;
  const classes = (0, _classnames.default)(`${prefix}table`, inset && `${prefix}table--inset`, fullWidth && `${prefix}table--full-width`, className);
  return _react.default.createElement("div", {
    className: classes
  }, _react.default.createElement("table", otherProps, children));
};
var _default = Table;
exports.default = _default;